"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = findKey;
function findKey(object, predicate) {
  return object.findKey(predicate);
}


//////////////////
// WEBPACK FOOTER
// ./~/react-redux-form/lib/utils/find-key-immutable.js
// module id = 2804
// module chunks = 0